import { ClipStatus } from "@/features/clips/types";
import { DownloadButtonState } from "./CameraDownloadIcon";

// Map clip status to download button state
export const getDownloadState = (status?: ClipStatus | string, hasClip?: boolean): DownloadButtonState => {
    if (!hasClip || !status) return 'default';

    // Normalize to uppercase to handle both 'ready' and 'READY' from API
    const normalizedStatus = typeof status === 'string' ? status.toUpperCase() : status;

    switch (normalizedStatus) {
        case ClipStatus.PENDING:
        case ClipStatus.PROCESSING:
        case ClipStatus.INITIALIZING:
            return 'generating';
        case ClipStatus.READY:
            return 'ready';
        case ClipStatus.ERROR:
        case ClipStatus.CANCELED:
        case ClipStatus.CANCELING:
            return 'error';
        default:
            return 'default';
    }
};